import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as RemoveIcon } from 'assets/remove-icon.svg';
import Select, { components } from 'react-select';
import Text from 'components/Text';

// Remove Icon
const MultiValueRemove = props => {
  return (
    <components.MultiValueRemove {...props}>
      <RemoveIcon fill="black" width="14" height="14" />
    </components.MultiValueRemove>
  );
};

const ClearIndicator = props => {
  return (
    <components.ClearIndicator {...props}>
      <RemoveIcon fill="#0779af" width="16" height="16" />
    </components.ClearIndicator>
  );
};

const MultiValueLabel = props => {
  const { children } = props;
  return (
    <components.MultiValueLabel {...props}>
      <Text fontSize="12px">{children}</Text>
    </components.MultiValueLabel>
  );
};

const MultiValueContainer = props => {
  // Render the remove icon before the label
  const { children } = props;
  return (
    <components.MultiValueContainer {...props}>
      {children[1]}
      {children[0]}
    </components.MultiValueContainer>
  );
};

const DropdownArrow = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 4px 4px 0 4px;
  border-color: #0d151f transparent transparent transparent;
`;
const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <DropdownArrow />
    </components.DropdownIndicator>
  );
};

const SelectableSearchInput = ({
  selected,
  onChange,
  isMulti,
  name,
  className,
  isError,
  options
}) => {
  const [select, setSelect] = useState(null);

  useEffect(() => {
    if (selected) {
      setDefaultSelectedValue(selected);
    }
  }, [selected]);

  const setDefaultSelectedValue = selected => {
    const selectedValue = Array.isArray(selected)
      ? selected.map(value => ({ value, label: value }))
      : { value: selected, label: selected };
    setSelect(selectedValue);
  };

  const handleOnChange = selectedItem => {
    setSelect(selectedItem);
    if (onChange) {
      onChange(selectedItem);
    }
  };

  return (
    <Select
      name={name}
      className={className} // for being wrapped by Styled component
      value={select || null}
      components={{
        ClearIndicator,
        MultiValueContainer,
        MultiValueRemove,
        MultiValueLabel,
        DropdownIndicator
      }}
      isMulti={isMulti}
      isClearable={true}
      isSearchable={true}
      onChange={handleOnChange}
      options={options.map(value => ({ value, label: value }))}
      placeholder="Select One/Search by ID"
      styles={{
        control: baseStyles => ({
          display: 'flex',
          flexWrap: 'wrap',
          border: '1px solid #e5e7eb',
          borderColor: isError ? '#EA6E6D' : '#e5e7eb !important',
          borderRadius: '2px'
        }),
        multiValue: baseStyles => ({
          ...baseStyles,
          alignItems: 'flex-end',
          backgroundColor: 'rgba(2, 104, 146, 0.3)',
          borderRadius: '2px',
          justifyContent: 'space-between'
        }),
        singleValue: baseStyles => ({
          ...baseStyles,
          fontSize: '12px',
          fontFamily: 'Crossten',
          fontWeight: '300',
          margin: '0'
        }),
        multiValueLabel: baseStyles => ({
          ...baseStyles,
          padding: '3px',
          paddingLeft: '3px',
          paddingRight: '7px'
        }),
        multiValueRemove: baseStyles => ({
          boxSizing: 'border-box',
          display: 'flex',
          cursor: 'pointer',
          padding: '2px',
          '&:hover': {
            opacity: '0.8'
          }
        }),
        clearIndicator: baseStyles => ({
          cursor: 'pointer',
          '&:hover': {
            opacity: '0.8'
          }
        }),
        placeholder: baseStyles => ({
          ...baseStyles,
          fontSize: '12px',
          fontFamily: 'Crossten',
          fontWeight: '300',
          margin: '0'
        }),
        indicatorSeparator: baseStyles => ({
          display: 'none'
        }),
        input: baseStyles => ({
          margin: '0'
        }),
        valueContainer: baseStyles => ({
          ...baseStyles,
          padding: '4px 8px'
        }),
        option: baseStyles => ({
          ...baseStyles,
          fontFamily: 'Crossten',
          fontSize: '12px'
        }),
        menu: baseStyles => ({
          ...baseStyles,
          zIndex: 6
        })
      }}
    />
  );
};

export default SelectableSearchInput;
